// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Added CSS to display placeholder for disabled field */
/* Commented out for now, can use it by uncommentting the lines when needed */
/* .disabledDatepicker::before {
  content: attr(data-placeholder);
  position: absolute;
  padding: 0 0.25rem 0 0.625rem;
  color: #0e0e0e9c;
  font-size: 14px;
  font-style: italic;
  text-overflow: ellipsis;
  line-height: 2.5;
  width: 78%;
  overflow: hidden;
  white-space: nowrap;
}

@media only screen and (max-width: 680px) {
  .disabledDatepicker::before {
    width: 52%;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/app/system-common/date-time-picker/date-time-picker.component.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD,6EAA6E;AAC7E;;;;;;;;;;;;;;;;;;GAkBG","sourcesContent":["/* Added CSS to display placeholder for disabled field */\r\n/* Commented out for now, can use it by uncommentting the lines when needed */\r\n/* .disabledDatepicker::before {\r\n  content: attr(data-placeholder);\r\n  position: absolute;\r\n  padding: 0 0.25rem 0 0.625rem;\r\n  color: #0e0e0e9c;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n  text-overflow: ellipsis;\r\n  line-height: 2.5;\r\n  width: 78%;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media only screen and (max-width: 680px) {\r\n  .disabledDatepicker::before {\r\n    width: 52%;\r\n  }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
